import React from 'react';
import styled from 'styled-components';
import { CheckCircleFilled } from '@ant-design/icons';

const colors = {
  primary: '#4A90E2',
  completed: '#5cb85c',
  inactive: '#d9d9d9',
  white: '#FFFFFF',
  text: '#2C3E50',
  lightText: '#999'
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
  padding: 0 16px;
  
  @media (max-width: 768px) {
    margin-bottom: 24px;
    overflow-x: auto;
    justify-content: flex-start;
    padding-bottom: 8px;
  }
`;

const StepsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  
  @media (max-width: 768px) {
    min-width: max-content;
  }
`;

const StepItem = styled.div`
  display: flex;
  align-items: center;
  
  &:last-child {
    .step-connector {
      display: none;
    }
  }
`;

const StepCircle = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  flex-shrink: 0;
  
  ${props => {
    if (props.$completed) {
      return `
        background-color: ${colors.completed};
        color: ${colors.white};
        border: 2px solid ${colors.completed};
      `;
    } else if (props.$active) {
      return `
        background-color: ${colors.primary};
        color: ${colors.white};
        border: 2px solid ${colors.primary};
        box-shadow: 0 0 0 4px rgba(74, 144, 226, 0.2);
      `;
    } else {
      return `
        background-color: ${colors.white};
        color: ${colors.inactive};
        border: 2px solid ${colors.inactive};
      `;
    }
  }}
  
  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
    font-size: 12px;
  }
`;

const StepLabel = styled.div`
  margin-left: 8px;
  font-size: 13px;
  font-weight: ${props => props.$active ? '600' : '400'};
  color: ${props => props.$active ? colors.text : colors.lightText};
  white-space: nowrap;
  transition: all 0.3s ease;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const StepConnector = styled.div`
  width: 40px;
  height: 2px;
  margin: 0 8px;
  background-color: ${props => props.$completed ? colors.completed : colors.inactive};
  transition: all 0.3s ease;
  
  @media (max-width: 768px) {
    width: 24px;
    margin: 0 4px;
  }
`;

const StepIndicator = ({ steps, currentStep }) => {
  return (
    <Container>
      <StepsWrapper>
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isActive = stepNumber === currentStep;
          
          return (
            <StepItem key={step.key || index}>
              <StepCircle $completed={isCompleted} $active={isActive}>
                {isCompleted ? (
                  <CheckCircleFilled style={{ fontSize: '20px' }} />
                ) : (
                  stepNumber
                )}
              </StepCircle>
              <StepLabel $active={isActive}>
                {step.title}
              </StepLabel>
              <StepConnector 
                className="step-connector" 
                $completed={isCompleted} 
              />
            </StepItem>
          );
        })}
      </StepsWrapper>
    </Container>
  );
};

export default StepIndicator;
